import { gql } from "@apollo/client";

const CREATE_USER_PLANT_SUBS = gql`
  mutation UserPlantSubscription(
    $userId: Int!
    $plantId: Int!
    $plantName: String!
  ) {
    createPlantSubscription(
      user_id: $userId
      plant_id: $plantId
      plant_name: $plantName
    ) {
      id
    }
  }
`;
const SUBSCRIBE_USER_TO_PLANT = gql`
  mutation SubscribeUserToPlant(
    $phone: String!
    $plant: PlantForSubscription
    $plantId: Int
    $queryId: String
  ) {
    subscribeUserToPlant(
      phone: $phone
      plant: $plant
      plant_id: $plantId
      query_id: $queryId
    )
  }
`;
const CREATE_USER_PLANT_SUBS_PHONE = gql`
  mutation UserPlantSubscriptionPhone(
    $userPhone: String!
    $plantId: Int!
    $plantName: String!
    $plantGivenName: String
  ) {
    createUserPlantSubsByPhone(
      user_phone: $userPhone
      plant_id: $plantId
      plant_name: $plantName
      plant_given_name: $plantGivenName
    ) {
      id
    }
  }
`;

const UPLOAD_FILE = gql`
  mutation uploadFile($file: Upload!) {
    uploadFile(file: $file) {
      ETag
      Location
      Key
      Bucket
    }
  }
`;

export {
  CREATE_USER_PLANT_SUBS,
  CREATE_USER_PLANT_SUBS_PHONE,
  UPLOAD_FILE,
  SUBSCRIBE_USER_TO_PLANT,
};
